<template>
  <div>
    <div class="px-4">
      <div
        v-for="strosek in stroski"
        :key="strosek.ID"
        class="d-flex align-center"
      >
        <div>
          DN {{ strosek.DN_ID }} strošek
          <strong>{{ strosek.Opis }}</strong>
        </div>
        <strong class="px-1"
          >{{ eur(strosek.Znesek_bruto) }} / s popustom
          {{ eur(strosek.Znesek_neto) }}</strong
        >
        <button v-if="edit" class="blue--text" @click="editPostavke(strosek)">
          🖉
        </button>
      </div>

      <div>
        <button v-if="edit" class="blue--text" @click="addPostavke()">
          Dodaj nov strošek
        </button>
      </div>
    </div>

    <v-dialog v-model="isopen" persistent max-width="600px">
      <v-form v-model="valid" ref="strosekForm">
        <v-card>
          <v-card-title>
            <span class="headline">Postavka delovnega naloga</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.Opis"
                    label="Opis"
                    required
                    placeholder="Opis del na delovnem nalogu"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-currency-field
                    v-model="form.Znesek_bruto"
                    label="Znesek brez popusta"
                    required
                    placeholder="Znesek za stranko"
                    flat
                    reverse
                    prefix="€"
                    :rules="[rules.required, rules.min]"
                  />
                </v-col>
                <v-col cols="6">
                  <v-currency-field
                    v-model="form.Znesek_neto"
                    label="Znesek s popustom"
                    required
                    placeholder="Dejansko plačano"
                    flat
                    reverse
                    prefix="€"
                    :rules="[rules.required, rules.min]"
                  />
                </v-col>
              </v-row>
              <v-row v-if="dialogError">
                <v-col cols="12">
                  <p>Napaka, javi Alešu kodo S2</p>
                  <p v-html="dialogError" class="red--text"></p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-8">
            <v-container fluid class="pa-0 ma-0">
              <v-btn
                color="blue white--text"
                @click="doSave(form.ID)"
                :disabled="!valid"
                class="float-right"
                >Shrani</v-btn
              >
              <v-btn
                color="red"
                text
                outlined
                @click="isopen = false"
                class="float-left"
                >Prekini</v-btn
              >
            </v-container>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import VCurrencyField from "@/modules/VCurrencyField";
import { parseCurrency } from "vue-currency-input";

export default {
  props: ["skoda", "edit"],
  components: {
    VCurrencyField,
  },
  data() {
    return {
      valid: false,
      stroski: [],
      dialog: false,
      isopen: false,
      form: {
        ID: 0,
        Opis: "",
        Znesek_bruto: 0.0,
        Znesek_neto: 0.0,
      },
      dialogError: null,
      loading: false,
      rules: {
        required: (value) => !!value || "Obvezen vnos",
        min: (v) => {
          var ret = true; // presume input is OK
          let error = parseCurrency(v, { valueAsInteger: false }) === 0;
          if (error) ret = "Znesek mora biti večji od 0";
          return ret;
        },
      },
    };
  },
  created() {
    this.getStroski();
  },
  methods: {
    getStroski() {
      var url = `/v_dn_postavke_po_skodi/${this.skoda.ID}`;
      this.$axios.get(url).then((response) => (this.stroski = response.data));
    },

    editPostavke(item) {
      this.form.ID = item.ID;
      this.form.Opis = item.Opis;
      this.form.Znesek_bruto = item.Znesek_bruto;
      this.form.Znesek_neto = item.Znesek_neto;
      this.isopen = true;
    },
    doSave(id) {
      let that = this;

      // patch, ker je edit, sicer post ker je new
      if (id != 0) {
        var url = `/dn_postavke/${id}`;
        this.$axios.patch(url, this.form).then((response) => {
          that.getStroski();
          that.isopen = false;
        });
      } else {
        var url = `/dn_postavke`;
        this.$axios.post(url, this.form).then((response) => {
          that.getStroski();
          that.isopen = false;
        });
      }
    },

    addPostavke() {
      this.form.ID = 0;
      this.form.DN_ID = this.skoda.DN_ID;
      this.form.Opis = "";
      this.form.Znesek_bruto = 0;
      this.form.Znesek_neto = 0;
      this.isopen = true;
    },
  },
};
</script>

<style scoped>
</style>
